import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, doc, getDoc, setDoc } from "firebase/firestore";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const hasFirebaseConfig = Object.values(firebaseConfig).every(Boolean);

let app = null;
let auth = null;
let db = null;

if (hasFirebaseConfig) {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  db = getFirestore(app);
} else {
  console.warn(
    "Firebase is not configured yet. Add REACT_APP_FIREBASE_* values to your environment to enable auth and Firestore."
  );
}

export const DEFAULT_SITE_CONTENT = {
  menuSectionTitle: "Imbiss Insel",
  menuSectionSubtitle: "Knuspriges Brot, saftiges Fleisch und frische Zutaten.",
  heroTitle: "Willkommen im Imbiss Insel Unterliederbach",
  heroSubtitle: "Echter Döner. Genuss, der verbindet.",
  menuImageDataUrl: "",
  menuTitle: "Menu",
  menuDescription: "Frisch zubereitete Klassiker und Spezialitaeten fuer jeden Geschmack.",
  mapTitle: "Hier findest du uns",
  mapDescription: "Frankfurt am Main – Schmalkaldener Str. 5 - Unterliederbach Bahnhof",
  galleryTitle: "Bilder aus unserem Imbiss Insel",
};

export { auth, db };

export async function getUserProfile(uid) {
  if (!db || !uid) {
    return null;
  }

  const profileRef = doc(db, "users", uid);
  const snapshot = await getDoc(profileRef);

  return snapshot.exists() ? snapshot.data() : null;
}

export async function ensureUserProfile(user) {
  if (!db || !user || !user.uid) {
    return { role: "user" };
  }

  const profileRef = doc(db, "users", user.uid);
  const snapshot = await getDoc(profileRef);

  if (!snapshot.exists()) {
    const profile = {
      uid: user.uid,
      email: user.email || "",
      role: "user",
      createdAt: new Date().toISOString(),
    };

    await setDoc(profileRef, profile);
    return profile;
  }

  return snapshot.data();
}

export async function saveSiteContent(content) {
  if (!db) {
    throw new Error("Firestore is not configured.");
  }

  const ref = doc(db, "siteContent", "landingPage");
  await setDoc(
    ref,
    {
      ...DEFAULT_SITE_CONTENT,
      ...content,
      updatedAt: new Date().toISOString(),
    },
    { merge: true }
  );
}

export async function getSiteContent() {
  if (!db) {
    return DEFAULT_SITE_CONTENT;
  }

  const ref = doc(db, "siteContent", "landingPage");
  const snapshot = await getDoc(ref);

  if (!snapshot.exists()) {
    return DEFAULT_SITE_CONTENT;
  }

  return { ...DEFAULT_SITE_CONTENT, ...snapshot.data() };
}
